import useUniversalStore from "store/universalStore";
import { Loader } from "components";
const CreditWallet = () => {
    const { user } = useUniversalStore();
    return user ?
        <iframe src={`https://app.sahukari.com/?sessionToken=${user?.getSessionToken()}&routeTo=credits?userId=${user?.id}`} width="100%" height="87%" />
        : <Loader />
}

export default CreditWallet;